<template>
  <div class="uk-margin">
    <!--<div v-if="meta" class="uk-text-muted uk-text-small">Noch {{ meta.pagination.total }} verfügbar</div>-->
    <div class="uk-grid uk-grid-small uk-flex uk-flex-middle uk-flex-between uk-margin" data-uk-grid>
      <div class="uk-width-expand">
        <div class="uk-grid" data-uk-grid>
          <div class="uk-width-1-3@m">
            <input
              type="text"
              class="uk-input"
              placeholder="Fahrzeug Nr."
              v-model="search.carId"
              @keyup.enter.prevent="activateFilter"
            />
          </div>
          <div class="uk-width-auto uk-flex uk-flex-middle">
            <a
              href="#"
              data-uk-icon="icon:refresh;ratio:0.8"
              class="uk-link-reset uk-text-small"
              @click.prevent="resetFilter"
              data-uk-tooltip="Filter zurücksetzen"
            ></a>
          </div>
        </div>
      </div>
      <div
        class="uk-width-auto@m"
        v-if="meta && meta.pagination.total_pages > 1"
      >
        <pagination :pagination="meta.pagination"></pagination>
      </div>
    </div>
    <table class="uk-table uk-table-middle uk-table-small uk-table-hover uk-table-divider">
      <thead>
        <tr>
          <th class="uk-table-shrink">
            <div class="uk-button-group checkbox">
              <div>
                <!--
                <label>
                  <input class="uk-checkbox" type="checkbox" @click="selectAll" v-model="allSelected" />
                </label>
                -->
              </div>
            </div>
          </th>
          <th style="width: 25px;">#</th>
          <th class="uk-table-shrink"></th>
          <th class="uk-table-expand">Fahrzeug</th>
          <th class="uk-width-small uk-text-right">B2B-VK netto</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="vehicle in vehicles" :key="vehicle.id" :class="{ highlight: value.includes(vehicle.id) }">
          <td class="uk-text-nowrap">
            <label>
              <input class="uk-checkbox" type="checkbox" :checked="value.includes(vehicle.id)"  @click="addSelected(vehicle.id)"/>
            </label>
          </td>
          <td @click.prevent="addSelected(vehicle.id)">
            {{ vehicle.carId }}
          </td>
          <td class="uk-text-nowrap" @click.prevent="addSelected(vehicle.id)">
            <img
              v-if="vehicle.images.length"
              class="uk-preserve-width"
              :src="vehicle.images[0]['400']"
              :alt="vehicle.name"
              width="40"
              height="40"
            />
            <img
              v-else
              class="uk-preserve-width"
              src="/img/placeholder.png"
              width="40"
              height="40"
            />
          </td>
          <td @click.prevent="addSelected(vehicle.id)">{{ vehicle.make }} {{ vehicle.model }} {{ vehicle.edition }}</td>
          <td class="uk-text-right" @click.prevent="addSelected(vehicle.id)">
            {{ vehicle.salepricemerchant | euro }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import VehicleService from '@/services/vehicle.service'
import Pagination from '@/components/Pagination'
import _ from 'lodash'
export default {
  props: ['value', 'packageId'],
  data() {
    return {
      vehicles: [],
      meta: null,
      checked: [],
      allSelected: false,
      search: {
        carId: null
      }
    }
  },
  components: { Pagination },
  mounted() {
    this.getVehicles()
  },
  watch: {
    '$route.query': {
      handler(query) {
        this.getVehicles(query.page)
      },
      deep: true
    }
  },
  methods: {
    getVehicles(page = this.$route.query.page) {
      this.search = _(this.search)
        .omitBy(_.isNull)
        .omitBy(_.isEmpty)
        .value()
      VehicleService.getListForPackages(this.packageId, page, { ...this.search }).then(response => {
        this.vehicles = response.data.vehicles
        this.meta = response.data.meta
      })
    },
    selectAll() {
      this.value = []
      if (!this.allSelected) {
        for (let vehicle in this.vehicles) {
          this.value.push(this.vehicles[vehicle].id)
        }
      }
    },
    addSelected(id) {
      if (this.value.includes(id)) {
        const index = this.value.indexOf(id)
        this.value.splice(index, 1)
      } else {
        this.value.push(id)
      }
    },
    activateFilter() {
      this.getVehicles(1)
    },
    resetFilter() {
      this.search.carId = null
      this.getVehicles(1)
    }
  }
}
</script>
<style lang="scss">
tr {
  &:hover {
    cursor: pointer;
  }
  &.highlight {
    background: #edf2f6 !important;
  }
}
</style>
